/**
 * Расстановка мягких переносов
 */

(function ($) {
    $(function () {
        Hyphenator.config({
            classname         : 'Hyphen',
            displaytogglebox  : false,
            minwordlength     : 4,
            intermediatestate : 'visible',
            doframes          : true,
            useCSS3hyphenation: true
        });
        Hyphenator.run();
    });
})(jQuery);
